export const state = () => ({
  sideArea: 'POS',
});

export const mutations = {
  SET_SIDE_AREA(state, payload) {
    state.sideArea = payload;
  },
};

export const actions = {
  toggleSidebar({ commit }, payload) {
    commit('SET_SIDE_AREA', payload);
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
